import './BalanceCard.css';

const BalanceCard = (props) => {

    function formatNumber(num) {
        if (num >= 1_000_000) {
            // Для чисел >= 1 миллиона: делим на миллион, форматируем с 2 знаками после точки
            return (num / 1_000_000).toFixed(2) + 'М';
        }

        // Для чисел < 1 миллиона: используем toLocaleString с 2 знаками для дробных чисел
        return num.toLocaleString('en', {
            minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
            maximumFractionDigits: 2
        });
    }

    return (
        <div className='balanceCard' style={{ backgroundImage: `url(${props.background})` }}>
            <div className='balanceCard__title appearanceAnimation'>{props.title} balance</div>
            <div className='balanceCard__balanceWrp'>
                <div className='balanceCard__valueIcon'>
                    <img src={props.icon} />
                </div>
                <div className='balanceCard__value appearanceAnimation'>{formatNumber(props.value)}</div>
            </div>
        </div>
    )
}

export default BalanceCard;